<template>
    <div id="app" class="app fond">
       <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>

                <section class="Section-pages" v-for="Mairie in listeMairies" :key="Mairie.id">
                    <section class="Fiche">
                        <div class="Infos Contact">
                            <table class="Tableau-Fiche Contact">
                                <tbody>
                                    <tr>
                                        <th colspan="2" class="colspandeux"><h6>Accessibilité</h6></th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="30" viewBox="0 0 21 30" class="logo-type-contact fill">
                                                <path id="Icon_material-place" data-name="Icon material-place" d="M18,3A10.492,10.492,0,0,0,7.5,13.5C7.5,21.375,18,33,18,33S28.5,21.375,28.5,13.5A10.492,10.492,0,0,0,18,3Zm0,14.25a3.75,3.75,0,1,1,3.75-3.75A3.751,3.751,0,0,1,18,17.25Z" transform="translate(-7.5 -3)"/>
                                            </svg>
                                        </th>
                                        <th>
                                            <a :href="Mairie.lien_adresse">{{Mairie.adresse}}</a>
                                            <br>
                                            <i>{{Mairie.complement_adresse}}</i>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" class="logo-type-contact fill">
                                                <path id="Icon_awesome-phone-alt" data-name="Icon awesome-phone-alt" d="M29.144,21.2l-6.563-2.813a1.406,1.406,0,0,0-1.641.4l-2.906,3.551A21.719,21.719,0,0,1,7.652,11.96L11.2,9.054a1.4,1.4,0,0,0,.4-1.641L8.8.85A1.416,1.416,0,0,0,7.184.036L1.09,1.442A1.406,1.406,0,0,0,0,2.813,27.185,27.185,0,0,0,27.188,30a1.406,1.406,0,0,0,1.371-1.09l1.406-6.094a1.423,1.423,0,0,0-.821-1.617Z" transform="translate(0 0)"/>
                                            </svg>
                                        </th>
                                        <th>
                                            <a :href="'tel:'+Mairie.telephone">{{Mairie.telephone}}</a>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="34.178" height="27" viewBox="0 0 34.178 27" class="logo-type-contact fill">
                                                <g id="Icon_feather-mail" data-name="Icon feather-mail" transform="translate(-0.911 -4.5)">
                                                <path id="Tracé_2" data-name="Tracé 2" d="M6,6H30a3.009,3.009,0,0,1,3,3V27a3.009,3.009,0,0,1-3,3H6a3.009,3.009,0,0,1-3-3V9A3.009,3.009,0,0,1,6,6Z" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                                <path id="Tracé_3" data-name="Tracé 3" d="M33,9,18,19.5,3,9" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                                </g>
                                            </svg>
                                        </th>
                                        <th>
                                            <a :href="'mailto:'+Mairie.email">{{Mairie.email}}</a>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <iframe class="contenu-droit-page" :src="Mairie.lien_adresse_iframe" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </section>
                    <section class="Fiche">
                        <section class="Infos">
                            <h3>Horaires</h3>
                            <table class="Tableau-Fiche">
                                <thead>
                                    <tr>
                                        <h6>Horaires par défaut</h6>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="jour in Mairie.horaires.body" :key="jour.id">
                                        <th v-for="colonne in jour" :key="colonne.id">{{colonne.c}}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                        <div class="contenu-droit-page">
                            <img :src="Mairie.image.url" alt="Mairie de Quenne">
                        </div>
                    </section>
                    <section class="Fiche">
                        <div>
                            <table class="Tableau-Fiche">
                                <thead>
                                    <tr>
                                        <h6>Horaires exceptionnels</h6>
                                    </tr>
                                    <tr>
                                        <th colspan="3">
                                            <p>Le secrétariat de mairie est fermé tous les jours fériés.</p>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th colspan="3"><h4>Les prochains jours avec des horaires exceptionnels</h4></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="jourException in DateSpeOrderByDate" :key="jourException.id">  
                                        <th v-if="jourException.date_de_fin === '' || jourException.date_de_fin === undefined || jourException.date_de_fin === null">{{jourException.dateFR}}</th>
                                        <th v-else>{{jourException.dateFR}} <br> au <br> {{jourException.dateFRFin}}</th>
                                        <th v-if="jourException.sujet_absence == 'Congé'" style="text-align: center">Secrétaire en congé</th>
                                        <th v-if="jourException.sujet_absence == 'Fermeture exceptionnelle'" style="text-align: center">Fermeture exceptionnelle</th>
                                        <th v-if="jourException.sujet_absence == 'Horaires exceptionnels'" style="text-align: center">Horaires exceptionnels</th>
                                        <th v-if="jourException.sujet_absence == 'Horaires exceptionnels'" style="text-align: center">{{jourException.horaires_matin}}</th>
                                        <th v-if="jourException.sujet_absence == 'Horaires exceptionnels'" style="text-align: center">{{jourException.horaires_aprem}}</th>
                                        
                                        <!--<th v-if="this.Ferie == true">{{}}</th>
                                        <th v-if="this.Ferie == true">Jour férié</th>-->

                                    </tr>
                                    <tr v-if="DateSpeOrderByDate.length == 0">
                                        <th>Aucune date spécifique prévue.</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="contenu-droit-page">
                            <img :src="Page.image" alt="Mairie de Quenne">
                        </div>
                    </section>
                    <section>
                        <section class="Fiche">
                            <section class="Infos">
                                <h6>Équipement AED/DAE</h6>
                                <p>{{Mairie.texte_dae}}</p>
                            </section>
                            <div class="contenu-droit-page">
                                <img :src="Mairie.image_dae.url" alt="DAE Mairie Place Anne PROT">
                            </div>
                        </section>
                        <section class="Fiche-emplacement">
                            <iframe :src="Mairie.lien_adresse_iframe_dae" class="Info-Emplacement" frameborder="0"></iframe>
                            <div class="Info-Emplacement">
                                <img :src="Mairie.visuels_dae[1].full_image_url" alt="Mairie de Quenne">
                            </div>
                        </section>
                    </section>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'Contact',
    data () {
        return{
            listeMairies:[],
            Ferie : false,
            date: null,
            time: null,
            joursemaine: null,
            datejour: null,
            listeJourFerie:[],
            listeHoraireSpe: null,
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            }
        }
    }, 

    created(){
        var currentdate = new Date();
        var date = new Date;
        var annee = date.getFullYear();
        var moi = date.getMonth();
        var mois = new Array('Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre');
        var moisnumerique = new Array('01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12');

        var j = date.getDate();
        if(j < 10){
            j = '0'+j
        }
        var jour = date.getDay();
        var jours = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
        this.date = jours[jour]+' '+j+' '+mois[moi]+' '+annee+'';
        this.time = currentdate.getHours()+" h "+currentdate.getMinutes()+" min "+currentdate.getSeconds()+" sec";
        this.joursemaine = jours[jour];
        this.datejour = +j+'/'+moi;
        this.dateJourNum = j+'/'+moisnumerique[moi]+'/'+annee;
        this.dateJourCompa = annee+'-'+moisnumerique[moi]+'-'+j
        this.dateJourCompaChiffre = annee+moisnumerique[moi]+j
        this.jourInfini = mois[moi];

        axios.get(param.host+'mairie/v1/listeMairies')
        .then(response =>{
            this.listeMairies = response.data;
        })
        .catch(error => console.log(error))

        axios.get(param.host+'horaireMairieSpe/v1/listeHoraireMairieSpe')
        .then(response =>{
            this.listeHoraireMairieSpe = response.data;
            console.log(this.listeHoraireMairieSpe);
            this.horaireSpe = '';
            j = 0;
            this.ProchainsJours = new Array;


            for(var i = 0; this.listeHoraireMairieSpe.length > i; i++){
                this.SplitDateDebut = new Array
                this.SplitDateDebut = this.listeHoraireMairieSpe[i].date.split('-');
                this.DateCompaDebut = this.SplitDateDebut[0]+this.SplitDateDebut[1]+this.SplitDateDebut[2]
                this.listeHoraireMairieSpe[i].dateFR = this.SplitDateDebut[2]+'/'+this.SplitDateDebut[1]+'/'+this.SplitDateDebut[0];



                if(this.listeHoraireMairieSpe[i].date_de_fin == null || this.listeHoraireMairieSpe[i].date_de_fin == '' || this.listeHoraireMairieSpe[i].date_de_fin == undefined){
                    if(this.DateCompaDebut >= this.dateJourCompaChiffre){
                        this.ProchainsJours[j] = this.listeHoraireMairieSpe[i]
                        j++
                    }
                }else{
                    this.SplitDateFin = new Array
                    this.SplitDateFin = this.listeHoraireMairieSpe[i].date_de_fin.split('-');
                    this.DateCompaFin = this.SplitDateFin[0]+this.SplitDateFin[1]+this.SplitDateFin[2]
                    this.listeHoraireMairieSpe[i].dateFRFin = this.SplitDateFin[2]+'/'+this.SplitDateFin[1]+'/'+this.SplitDateFin[0];


                    if(this.DateCompaFin >= this.dateJourCompaChiffre){
                        this.ProchainsJours[j] = this.listeHoraireMairieSpe[i]
                        j++
                    }
                }

            }
        })
        .catch(error => console.log(error))

        axios.get('https://calendrier.api.gouv.fr/jours-feries/metropole/'+annee+'.json')
        .then(response =>{
            this.listeJourFerie = response.data;

            this.json = [];
            var i = 0;
            let jourferie = null;
            for(jourferie in this.listeJourFerie){
                let test = jourferie.split('-')
                let datefr = test[2]+'/'+test[1]+'/'+test[0];

                if(this.dateJourNum === datefr){
                    this.Ferie = true;
                }else{
                    this.Ferie = false
                }


                this.json[i] = datefr;
                
                i++;
            }
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Contact'){
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))
    },

    computed:{
        DateSpeOrderByDate: function(){
            function compare(a, b){
                    if(a.date < b.date) return -1
                    if(a.date > b.date) return 1
                    return 0
                }
                return this.ProchainsJours.sort(compare)
        }
    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Contact.vue